module.exports = __webpack_public_path__ + "img/rads.5a97cd96.svg";